import React from "react";
import { getReviewTemplateList } from "../../helpers/backend_helper";
import TemplateList from "./TemplateList";
import ReviewTemplateStudio from "./ReviewTemplateStudio";

const ReviewTemplateList = ({ refreshRequest = 0 }) => (
  <TemplateList
    refreshRequest={refreshRequest}
    label="Review Template"
    pluralLabel="Review Templates"
    listTemplates={() => getReviewTemplateList(true)}
    StudioComponent={ReviewTemplateStudio}
    fileName="review-templates"
  />
);

export default ReviewTemplateList;
